import { APIRoute } from '@/modules/utils'

export const Route: APIRoute = {
  method: 'PATCH',
  path: '/v2/account/change-password',
}

export type Response = never

export type Body = {
  oldPassword: string
  plainPassword: {
    first: string
    second: string
  }
}
